/** @jsx jsx */
import React from "react"
import { jsx } from '@emotion/react'
import { card, col_card, SectionStyled } from '../assets/styles/EducacaoInfantilSliderContainer.styles'
import { Col, Container, Row } from 'react-bootstrap'
import CardSlider from './cardsSliderFundamental'
import MapLocation from '../assets/icons/mapLocationPurple-icon.svg'

const EducacaoInfantilSliderContainer = () => {
  return (
    <section css={SectionStyled} id="estrutura-school">
      <Container fluid>
        <Row>
          <Col
            css={col_card}
            data-aos="fade-right"
            lg={4}
            md={4}
            sm={12}
          >
            <div css={card}>
              <h2>
                Ambiente formativo e estrutura pedagógica
              </h2>
              <h3 style={{ color: '#000F3A' }}>
                <img src={MapLocation} /> Ensino Fundamental - QI 11 - Lago Sul
              </h3>
              <p>
                Uma estrutura pensada para sustentar uma rotina de estudos mais concreta, com salas de aula-laboratório e projetos integrados ao currículo. Os ambientes favorecem foco, autonomia e participação ativa no processo de aprendizagem.
              </p>
            </div>
          </Col>
          <Col lg={8} md={8} sm={12}>
            <CardSlider />
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default EducacaoInfantilSliderContainer
